import { render, staticRenderFns } from "./stream-chat-clear.vue?vue&type=template&id=05a539a1"
import script from "./stream-chat-clear.vue?vue&type=script&lang=js"
export * from "./stream-chat-clear.vue?vue&type=script&lang=js"
import style0 from "./stream-chat-clear.vue?vue&type=style&index=0&id=05a539a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports